__turbopack_context__.v({
  "buttonContainer": "Differences-module-scss-module__q8C53G__buttonContainer",
  "calculaterInputRent": "Differences-module-scss-module__q8C53G__calculaterInputRent",
  "calculaterInputSale": "Differences-module-scss-module__q8C53G__calculaterInputSale",
  "calculatorContent": "Differences-module-scss-module__q8C53G__calculatorContent",
  "calculatorInner": "Differences-module-scss-module__q8C53G__calculatorInner",
  "calculatorResult": "Differences-module-scss-module__q8C53G__calculatorResult",
  "calculatorResultItem": "Differences-module-scss-module__q8C53G__calculatorResultItem",
  "content": "Differences-module-scss-module__q8C53G__content",
  "differences": "Differences-module-scss-module__q8C53G__differences",
  "differencesTable": "Differences-module-scss-module__q8C53G__differencesTable",
  "inner": "Differences-module-scss-module__q8C53G__inner",
  "inputContainer": "Differences-module-scss-module__q8C53G__inputContainer",
  "saleTitle": "Differences-module-scss-module__q8C53G__saleTitle",
  "tableHeader": "Differences-module-scss-module__q8C53G__tableHeader",
  "tableHeaderEmpty": "Differences-module-scss-module__q8C53G__tableHeaderEmpty",
  "tableHeaderItem": "Differences-module-scss-module__q8C53G__tableHeaderItem",
  "tableLeft": "Differences-module-scss-module__q8C53G__tableLeft",
  "tableLeftContent": "Differences-module-scss-module__q8C53G__tableLeftContent",
  "tableLeftTitle": "Differences-module-scss-module__q8C53G__tableLeftTitle",
  "tableRight": "Differences-module-scss-module__q8C53G__tableRight",
  "tableRightContent": "Differences-module-scss-module__q8C53G__tableRightContent",
  "tableRightContentPadding": "Differences-module-scss-module__q8C53G__tableRightContentPadding",
  "tableRightTitle": "Differences-module-scss-module__q8C53G__tableRightTitle",
  "tableRightinner": "Differences-module-scss-module__q8C53G__tableRightinner",
  "title": "Differences-module-scss-module__q8C53G__title",
  "titleContent": "Differences-module-scss-module__q8C53G__titleContent",
  "usageCalculator": "Differences-module-scss-module__q8C53G__usageCalculator",
  "usageCalculatorContent": "Differences-module-scss-module__q8C53G__usageCalculatorContent",
  "usageCalculatorRent": "Differences-module-scss-module__q8C53G__usageCalculatorRent",
  "usageCalculatorSale": "Differences-module-scss-module__q8C53G__usageCalculatorSale",
  "usageKoreanContainer": "Differences-module-scss-module__q8C53G__usageKoreanContainer",
  "wrap": "Differences-module-scss-module__q8C53G__wrap",
});
